// ---- UNIVERSAL ADDED-TO-CART TRACKER ----
window._learnq = window._learnq || [];

// Wait until Klaviyo is ready to receive events
function whenLearnqReady(cb, tries){ tries = tries || 40; if (window._learnq && typeof _learnq.push==='function') return cb(); if(tries<=0) return; setTimeout(function(){ whenLearnqReady(cb, tries-1); },100); }
function klTrack(name, props){ whenLearnqReady(function(){ window._learnq.push(['track', name, props||{}]); console.log('[CK ATC] pushed to Klaviyo:', name, props); }); }

// Build event from a cart line item
function trackATCFromItem(item){
  if(!item) return;
  var name  = item.product_title || item.title || item.handle || 'Product';
  var id    = item.variant_id || item.id || item.product_id;
  var price = (typeof item.final_price==='number'? item.final_price : (typeof item.price==='number'? item.price : 0)) / 100;
  var image = item.image || (item.featured_image && (item.featured_image.url || item.featured_image)) || null;
  klTrack('Added to Cart', { Name:name, ProductID:id, Price:price, URL:location.href, ImageURL:image });
}

var lastCount = null;
function readCartAndTrack(){
  fetch('/cart.js', {credentials:'same-origin'})
    .then(function(r){ return r.json(); })
    .then(function(cart){
      if (typeof lastCount==='number' && cart.item_count <= lastCount) return; // no increase
      lastCount = cart.item_count;
      var item = cart.items && cart.items[cart.items.length-1];
      console.log('[CK ATC] cart read:', {item_count: cart.item_count, last_item: item && (item.title || item.product_title)});
      trackATCFromItem(item);
    })
    .catch(function(e){ console.warn('[CK ATC] cart read failed', e); });
}

function afterDelayCheck(){
  setTimeout(readCartAndTrack, 900);
  setTimeout(readCartAndTrack, 1600);
}

// 1) Form submit to /cart/add (if theme uses it)
document.addEventListener('submit', function(e){
  try{
    var el = e.target;
    if (el && el.matches && el.matches("form[action*='/cart/add']")) afterDelayCheck();
  }catch(_){}
}, true);

// 2) Common quick-add buttons/links
document.addEventListener('click', function(e){
  try{
    var el = e.target && e.target.closest && e.target.closest('button, a, input[type="submit"]');
    if (!el) return;
    var txt = (el.getAttribute('aria-label') || el.textContent || '').toLowerCase();
    var name = el.getAttribute('name') || '';
    var data = el.getAttribute('data-add-to-cart') || el.getAttribute('data-action') || '';
    var looksLikeATC =
      name==='add' ||
      /add to cart|quick add|buy now/.test(txt) ||
      /add|cart/.test(data) ||
      (el.matches && el.matches("[data-add-to-cart], [data-action*='add'], .quick-add, .ajax-add-to-cart, .product-form__submit"));
    if (looksLikeATC) afterDelayCheck();
  }catch(_){}
}, true);

// 3) Theme events many themes dispatch
['cart:updated','cart:after-add','product:added','ajaxProduct:added','cart:change','cart:refresh'].forEach(function(evt){
  document.addEventListener(evt, function(){ setTimeout(readCartAndTrack, 400); });
});

// 4) GraphQL Storefront API (cartLinesAdd, cartCreate, etc.)
(function wrapFetch(){
  var orig = window.fetch;
  window.fetch = function(resource, init){
    var body = (init && init.body) || (resource && resource.body) || '';
    var isGraphQL = (typeof body === 'string') && /cartLinesAdd|cartCreate|cartLinesUpdate/i.test(body);
    var p = orig.apply(this, arguments);
    if (isGraphQL) { p.then(function(resp){ if(resp && resp.ok) afterDelayCheck(); }).catch(function(){}); }
    return p;
  };
})();

// 5) As a last resort, observe cart count DOM changes
(function observeCartCount(){
  var targets = Array.prototype.slice.call(document.querySelectorAll('.cart-count,[data-cart-count],.header__icon--cart .count,.mini-cart__count'));
  if (!targets.length) return;
  var obs = new MutationObserver(function(){ afterDelayCheck(); });
  targets.forEach(function(t){ obs.observe(t, {childList:true, characterData:true, subtree:true}); });
})();

console.log('[CK ATC] universal ATC tracker active');